var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',_vm._b({attrs:{"number-to-display":3,"hide-default-bg-image":""}},'page',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }